export default {
  key: "creditNoteDocumented",
  serviceKey: "hrdc",
  name: {
    singular: "Credit Note Documented",
    plural: "Credit Note Documented",
  },
  parents: [
    //
  ],
  add: {
    name: "Credit Note Documented",
  },
  view: {
    name: "Credit Note Documented",
  },
};
